"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFragmentTypePolicyFieldName = void 0;
const client_1 = require("@apollo/client");
const react_1 = require("react");
const helpers_1 = require("../helpers");
// Creates a field name to be used for a dynamically added field policy.
const useFragmentTypePolicyFieldName = () => {
    const { current: fieldName } = (0, react_1.useRef)((0, helpers_1.generateFragmentFieldName)());
    const client = (0, client_1.useApolloClient)();
    (0, react_1.useEffect)(() => 
    // @ts-ignore After the component using the hook is torn down, remove the dynamically added type policy
    // for this hook from the type policies list.
    () => delete client.cache.policies.typePolicies.Query.fields[fieldName], []);
    return fieldName;
};
exports.useFragmentTypePolicyFieldName = useFragmentTypePolicyFieldName;
//# sourceMappingURL=useFragmentTypePolicyFieldName.js.map